// extracted by mini-css-extract-plugin
export default {"inputWrapper":"styles__inputWrapper--Wb54H","input":"styles__input--Saa65"};